export default [
    {
        path: '/c/:code',
        name: 'coupon',
        component: () => import(/* webpackChunkName: "raf" */ '@/views/ReferenceFromAFriend'),
        props: true,
    },
];
